import { useTranslation } from '@shared/core';
import { Invitation, Share, Website, MailingAddress, Diamond, Mobile } from '@withjoy/joykit/icons';
import React, { useMemo } from 'react';
import { CustomizeNowButton } from '../../CustomizeNowButton';
import { ListValueProps } from '../ValueProps/ValueProps';
import { useFeatureValue } from '@shared/core/featureFlags';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { MatchingFoilTemplate } from '../MatchingFoilTemplate';
interface PremiumDigitalCustomizationPaneProps {
  onCustomizeClick: () => void;
  isCreatingDraft: boolean;
  intersectionRef: React.RefObject<HTMLButtonElement>;
  hideCustomizeNowButton?: boolean;
  disableCustomizeNowButton?: boolean;
  category: StationeryTemplateCategoryEnum;
  themeId: string;
}

export const PremiumDigitalCustomizationPane = (props: PremiumDigitalCustomizationPaneProps) => {
  const { disableCustomizeNowButton, onCustomizeClick, hideCustomizeNowButton, isCreatingDraft, intersectionRef, category, themeId } = props;
  const { t2 } = useTranslation('stationery');
  const { value } = useFeatureValue('printDigitalSMSUpsellEnabled');
  const smsUpsellEnabled = value === 'on';
  const isFoilCrossSellEnabled = useFeatureValue('printEnableFoilCrossSellPdp').value === 'on';

  const { listValueProps } = useMemo(() => {
    const { listValueProps } = t2('pdpModal', 'customizationPane', 'premiumDigitalTemplateConfig');
    const valueProps = {
      listValueProps: {
        sectionTitle: listValueProps.sectionTitle,
        items: [
          {
            icon: (
              <Diamond
                size={24}
                alignSelf="flex-start"
              />
            ),
            title: listValueProps.premium.title,
            description: listValueProps.premium.description,
          },
          {
            icon: (
              <Website
                size={24}
                alignSelf="flex-start"
              />
            ),
            title: listValueProps.matchingPaperCards.title,
            description: listValueProps.matchingPaperCards.description,
          },
          {
            icon: (
              <Invitation
                size={24}
                alignSelf="flex-start"
              />
            ),
            title: listValueProps.personalizedEmail.title,
            description: listValueProps.personalizedEmail.description,
          },
          {
            icon: (
              <Share
                size={24}
                alignSelf="flex-start"
              />
            ),
            title: listValueProps.shareableLink.title,
            description: listValueProps.shareableLink.description,
          },
          {
            icon: (
              <MailingAddress
                size={24}
                alignSelf="flex-start"
              />
            ),
            title: listValueProps.contactCollector.title,
            description: listValueProps.contactCollector.description,
          },
        ],
      },
    };
    // We only show the text message value prop if text messaging is enabled
    if (smsUpsellEnabled) {
      valueProps.listValueProps.items.splice(2, 0, {
        icon: (
          <Mobile
            size={24}
            alignSelf="flex-start"
          />
        ),
        title: listValueProps.textMessage.title,
        description: listValueProps.textMessage.description,
      });
    }
    return valueProps;
  }, [t2, smsUpsellEnabled]);

  return (
    <>
      <CustomizeNowButton
        ref={intersectionRef}
        hide={hideCustomizeNowButton}
        isLoading={isCreatingDraft}
        onCustomizeClick={onCustomizeClick}
        disabled={disableCustomizeNowButton}
        marginBottom={6}
      />
      <ListValueProps
        marginBottom={6}
        items={listValueProps.items}
        sectionTitle={listValueProps.sectionTitle}
      />
      {isFoilCrossSellEnabled && (
        <MatchingFoilTemplate
          category={category}
          themeId={themeId}
        />
      )}
    </>
  );
};
